const commonActionController = require('frontend-controller/lib/controllers/common')

module.exports = {
    events: {
        showChangeNotes: {
            selector: '.version',
            type: 'click',
            action: event => {
                event.stopImmediatePropagation()

                const user = (storage || {}).user
                if(user && user.hasAccessToDocs('changeNotes')){
                    globalThis.open('/~/docs/changeNotes/index')
                }
            }
        },
        showAdminPanel: {
            selector: 'button',
            type: 'click',
            action: event => {
                event.stopImmediatePropagation()

                const self = event.data.component
                const $target = $(event.target).closest('button')
                if($target.length > 0){
                    if($target.data('fieldType') === 'showAdminPanel'){
                        self.showAdminPanel()
                    }
                }
            }
        },
        heartbeatConnect: {
            selector: '.heartbeatConnection',
            type: 'click',
            action: event => {
                event.stopImmediatePropagation()

                heartbeatController.reconnect(true)
            }
        },
        // toggleProfileManagement: {
        //     selector: '.user',
        //     type: 'click',
        //     action: event => {
        //         const self = ((event || {}).data || {}).component
        //         if(((self || {}).model || {}).showProfileManagement){
        //             event.stopImmediatePropagation()
        //             self.toggleProfileManagement()
        //         }
        //     }
        // },
        logout: {
            selector: '.logout',
            type: 'click',
            action: event => {
                event.stopImmediatePropagation()

                const self = ((event || {}).data || {}).component
                if(self){
                    self.logout()
                }
            }
        },
    },

    methods: {
        async showAdminPanel(){
            await this.performAndStoreAction(
                'showAdminPanel_inEffect',
                this.prepareAction('showAdminPanel')
            )
        },
        heartbeatConnectionStateChanged(connected){
            if(connected){
                this.$.find('.heartbeatConnection').addClass('connected')
            } else {
                this.$.find('.heartbeatConnection').removeClass('connected')
            }
        },
        // async toggleProfileManagement(forceProfileManagementActiveValue){
        //     const $user = this.$.find('.main > .user')
        //     if(forceProfileManagementActiveValue !== undefined){
        //         this.model.profileManagementActive = !!forceProfileManagementActiveValue
        //     } else {
        //         this.model.profileManagementActive = !this.model.profileManagementActive
        //     }
        //     if(this.model.profileManagementActive){
        //         $user.addClass('active')
        //
        //         const baseActionKey = 'showEdit_profileManagement'
        //         const actionKey = `${baseActionKey}_inEffect`
        //
        //         await this.performAndStoreAction(
        //             actionKey,
        //             this.prepareAction(baseActionKey, undefined, undefined, undefined),
        //             true
        //         )
        //     } else {
        //         $user.removeClass('active')
        //     }
        // },
        logout(){
            return this.performAction(
                this.prepareAction(commonActionController.getAction('logout'))
            )
        },
    },

    hooks: {
        async onDecision($element, options){

            let modal, modalContentComponent
            switch(options.decisionComponent.componentClass) {
                case 'base_modal_modal':
                case 'templates_core_modal_modal':
                    modal = options.decisionComponent
                    modalContentComponent = modal.actions.loadContent.source.load.component
                    break
            }

            // if(modalContentComponent.hasClass('templates_crew_profile_controller')){
            //     this.toggleProfileManagement(false)
            // }

            if(modal){
                await modal.hide()
            }
        },
    },

    handlers: [
        {
            name: 'heartbeat.connectionStateChanged',
            handle: function(callerComponent, connected){
                this.heartbeatConnectionStateChanged(connected)
            }
        },
    ]
}